import axios from "axios";
export async function testConnectivity(endpointUrl, authApiUsername, authApiPassword){
    try {
      if (authApiUsername) {
        const response = await axios.post(
          endpointUrl, 
          { username: authApiUsername, password: authApiPassword },
          { headers: { "Content-Type": "application/json" } }
        );
        return (response.status === 200 || response.status === 201) ? "success" : "failed";
      } else {
        const response = await axios.get(
          endpointUrl,
          { headers: { "Content-Type": "application/json" } }
        );
        return (response.status === 200 || response.status === 201) ? "success" : "failed";
      }
    } catch (error) {
      console.log(error)
      return "failed";
    }
  };

  

